import {jobsEndpoint} from './routes';
import {createEngineerDayQueryString, createEngineerJobQueryString, createDateQueryStringParam} from './query-string-service';
import {validateResponse} from "./http-service"; 

export let getDayJobsForEngineer = async (engineerId, date) => {
    const res = await fetch(jobsEndpoint + createEngineerDayQueryString(engineerId, date));
    return await res.json();
};

export let getDaysJobs = async (date) => {
    const res = await fetch(jobsEndpoint + "?"  + createDateQueryStringParam(date));
    return await res.json();
};

export let getJob = async (jobId) => {
    const res = await fetch(jobsEndpoint + "/manage?jobId=" + jobId);
    return await res.json();
};

export let markJobComplete = async (jobId, engineerId) => {
    return fetch(jobsEndpoint + "/complete" + createEngineerJobQueryString(engineerId, jobId), { method: "PUT" })
        .then((res) => validateResponse(res, "mark job complete"));
};

export let updateJobPositions = async (jobs, engineerId) => {    
    return fetch(jobsEndpoint + "/positions?engineerId=" + engineerId, crudRequestOptions("PUT", jobs))
    .then((res) => validateResponse(res, "update job position"));
};

export let saveJob = async (job) => {

    console.log(JSON.stringify(job));

    return await fetch(jobsEndpoint, crudRequestOptions("POST", job))
        .then((res) => validateResponse(res, "save job"))
        .then(res => res.text());
};

export let deleteJob = async (jobId) => {
    return await fetch(jobsEndpoint + "?jobId=" + jobId, { method: "DELETE" })
        .then((res) => validateResponse(res, "delete job"));
};

let crudRequestOptions = (method, body) => {
    return { 
        method: method,
        headers: {
            'content-type': 'application/json',
        },
        body: JSON.stringify(body),
    };
};